// Pull the file name the server chose out of a Content-Disposition header. A streamed download
// carries its name here, not in the URL, and ASP.NET writes both an RFC 5987 filename* (percent
// encoded, UTF-8) and a plain filename; filename* is the authoritative one when present.
const parseContentDispositionFilename = (header, fallback = 'download') => {
  if (!header) return fallback

  const extended = header.match(/filename\*=(?:UTF-8'')?([^;]+)/i)
  if (extended && extended[1]) {
    try {
      return decodeURIComponent(extended[1].trim())
    } catch (e) {
      return extended[1].trim()
    }
  }

  const plain = header.match(/filename="?([^";]+)"?/i)
  if (plain && plain[1]) {
    return plain[1].trim()
  }

  return fallback
}

export default parseContentDispositionFilename
